
import Clarity from "@microsoft/clarity";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import AuthIllustration from "../common/AuthIllustration";
import AuthShell from "../common/AuthShell";
import Form from "./Form";

export default function Login() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(window.innerWidth > 768);

	return (
		<>
			<Helmet>
				<title>ورود | همراهتیم</title>
				<meta name="description" content="ورود به همراهتیم" />
			</Helmet>

			<AuthShell isDesktop={isDesktop}>
				<AuthIllustration />
				<Form />
			</AuthShell>
		</>
	);
}
